/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserPopoverContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverOverviewContainer_viewer">;
    readonly " $refType": "UserPopoverContainer_viewer";
};
export type UserPopoverContainer_viewer$data = UserPopoverContainer_viewer;
export type UserPopoverContainer_viewer$key = {
    readonly " $data"?: UserPopoverContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPopoverContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPopoverOverviewContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '7cfa25b6d4e2737f1e6629dd743c4b45';
export default node;
